module.exports = __webpack_public_path__ + "static/media/bk-home-active.fa74eb6a.png";